/** 결재 대기함 건수 갱신 (헤더 뱃지 · 팝업 창 포함) */
const CHANNEL = 'duzon-approval-inbox';

export type ApprovalInboxChangeDetail = {
  count?: number;
};

export function notifyApprovalInboxChanged(count?: number) {
  const detail: ApprovalInboxChangeDetail =
    typeof count === 'number' && Number.isFinite(count) ? { count: Math.max(0, Math.floor(count)) } : {};
  try {
    const ch = new BroadcastChannel(CHANNEL);
    ch.postMessage({ type: 'changed', at: Date.now(), ...detail });
    ch.close();
  } catch {
    // BroadcastChannel 미지원 환경
  }
  window.dispatchEvent(new CustomEvent('duzon:approval-inbox-changed', { detail }));
}

export function subscribeApprovalInboxChanged(
  onChange: (detail?: ApprovalInboxChangeDetail) => void
): () => void {
  const onWindow = (event: Event) => {
    const detail = (event as CustomEvent<ApprovalInboxChangeDetail>).detail;
    onChange(detail);
  };
  window.addEventListener('duzon:approval-inbox-changed', onWindow);

  let ch: BroadcastChannel | null = null;
  try {
    ch = new BroadcastChannel(CHANNEL);
    ch.onmessage = (event) => {
      const data = event.data as ApprovalInboxChangeDetail | null;
      onChange(data || undefined);
    };
  } catch {
    ch = null;
  }

  return () => {
    window.removeEventListener('duzon:approval-inbox-changed', onWindow);
    ch?.close();
  };
}
